// Import assets for panonara view.
import './assets/js/pano2vr_player';
import '@fontsource/nunito-sans';

import { Suspense } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import {
  CssBaseline,
  StyledEngineProvider,
  ThemeProvider,
} from '@mui/material';

import { BackdropLoader } from './components';
import { TourProvider } from './contexts';
import Routes from './routes';
import theme from './styles';

function App() {
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router>
          <Suspense fallback={<BackdropLoader open />}>
            <TourProvider>
              <Routes />
            </TourProvider>
          </Suspense>
        </Router>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

export default App;
